import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { whatsappUrl, telUrl, DEFAULT_WA_MESSAGE } from "@/lib/contact";

export default function FloatingCTA() {
  return (
    <>
      {/* Desktop: floating WhatsApp bubble bottom-right */}
      <a
        href={whatsappUrl(DEFAULT_WA_MESSAGE)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Falar no WhatsApp"
        className="fixed bottom-6 right-6 z-50 hidden h-16 w-16 items-center justify-center rounded-full bg-brand-whatsapp shadow-[0_0_30px_rgba(37,211,102,0.5)] transition-transform duration-300 hover:scale-110 md:flex"
      >
        <span className="absolute inset-0 rounded-full bg-brand-whatsapp animate-pulse-ring" aria-hidden="true" />
        <WhatsappLogo weight="fill" className="relative h-8 w-8 text-white" />
      </a>

      {/* Mobile: sticky bottom bar with both actions */}
      <div
        data-testid="mobile-sticky-cta"
        className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-white/10 bg-black/80 backdrop-blur-xl md:hidden"
      >
        <a
          href={telUrl()}
          data-testid="mobile-call"
          className="flex items-center justify-center gap-2 py-4 font-heading text-sm font-semibold uppercase tracking-wide text-white"
        >
          <Phone weight="fill" className="h-5 w-5 text-brand-red" /> Ligar
        </a>
        <a
          href={whatsappUrl(DEFAULT_WA_MESSAGE)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-whatsapp-bar"
          className="flex items-center justify-center gap-2 bg-brand-whatsapp py-4 font-heading text-sm font-semibold uppercase tracking-wide text-white"
        >
          <WhatsappLogo weight="fill" className="h-5 w-5" /> WhatsApp
        </a>
      </div>
    </>
  );
}
